export default "<div class=\"splashbox\">\r\n    <p class=\"center\">404</p>\r\n    <h2 class=\"center\">Page not found</h2>\r\n</div>\r\n"